/* src/app/shared/shop/product-card/product-card-info/product-card-info.component.scss */
.image-container {
  width: 100%;
  height: 100%;
  position: relative;
}
img {
  width: 100%;
  height: 100%;
  max-width: 500px;
  vertical-align: middle;
  object-fit: cover;
}
.title-message {
  font-family: Barlow Semi Condensed;
  font-size: 24px;
  font-weight: 500;
  line-height: 28.8px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
@media (max-width: 1104px) {
  .title-message {
    font-size: 20px;
    line-height: 24px;
  }
}
.sub-message:hover {
  color: var(--ion-color-tertiary);
}
.variantTag {
  font-family: "Barlow Semi Condensed", sans-serif;
  font-weight: 400;
  color: white;
  font-size: 15px;
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 5px 10px;
  background: black;
  cursor: pointer;
  border-radius: 6px;
}
.image-container img {
  position: absolute;
  transition: opacity 0.5s ease-in-out;
  opacity: 1;
}
.image-container img.hiddenImg {
  opacity: 0;
}
app-product-label,
.variantTag {
  z-index: 9;
}
.view-details {
  min-height: 0;
  margin: 0;
  margin-top: 5px;
}
.view-details::part(native) {
  padding: 0;
}
.product-info {
  padding: 20px;
}
.added-confirmation {
  background-color: #0acf83;
  color: #f6f6f6;
  padding: 16px 15px;
  font-size: 20px;
  z-index: 999;
  height: 60px;
}
.fade-in-out {
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.fade-in-out:not([hidden]) {
  opacity: 1;
}
/*# sourceMappingURL=product-card-info.component-OOJP3MNB.css.map */
